import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.ODONTOGRAMA.ATUALIZAR_ODONTOGRAMA](state, atualizar) {
        state.atualizarOdontograma = atualizar
    },
}